import { render, staticRenderFns } from "./FosterParentTraining.vue?vue&type=template&id=58b30f19&scoped=true&"
import script from "./FosterParentTraining.vue?vue&type=script&lang=js&"
export * from "./FosterParentTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b30f19",
  null
  
)

export default component.exports